export var IdIcon;
(function (IdIcon) {
    IdIcon["AccountSettingsIcn"] = "AccountSettingsIcn";
    IdIcon["AdditionalSettingsIcn"] = "AdditionalSettingsIcn";
    IdIcon["AdventureIcn"] = "AdventureIcn";
    IdIcon["AllianceDeputyIcn"] = "AllianceDeputyIcn";
    IdIcon["AllianceIcn"] = "AllianceIcn";
    IdIcon["AllianceLeaderIcn"] = "AllianceLeaderIcn";
    IdIcon["AllianceMemberIcn"] = "AllianceMemberIcn";
    IdIcon["AsianIcn"] = "AsianIcn";
    IdIcon["AsianThemedEventTask_1_Icn"] = "Asian_Task1_Icn";
    IdIcon["AsianThemedEventTask_2_Icn"] = "InkPaintingsIcn";
    IdIcon["AsianThemedEventTask_3_Icn"] = "Asian_Task3_Icn";
    IdIcon["AsianThemedEventTask_4_Icn"] = "CherryBlossomsIcn";
    IdIcon["AsianThemedEventTask_5_Icn"] = "Asian_Task5_Icn";
    IdIcon["AsianThemedEventTask_6_Icn"] = "OrigamiCranesIcn";
    IdIcon["BadgePremiumIcn"] = "BadgePremiumIcn";
    IdIcon["BadgeTournamentIcn"] = "Badge_Tournament_Icn";
    IdIcon["BlogIcn"] = "BlogIcn";
    IdIcon["BuildIcn"] = "BuildIcn";
    IdIcon["CafeIcn"] = "CafeIcn";
    IdIcon["CampingIcn"] = "CampingIcn";
    IdIcon["CampingThemedEventTask_1_Icn"] = "FirewoodIcn";
    IdIcon["CampingThemedEventTask_2_Icn"] = "Camping_Task2_Icn";
    IdIcon["CampingThemedEventTask_3_Icn"] = "TracksIcn";
    IdIcon["CampingThemedEventTask_4_Icn"] = "Camping_Task4_Icn";
    IdIcon["CampingThemedEventTask_5_Icn"] = "MapPiecesIcn";
    IdIcon["CampingThemedEventTask_6_Icn"] = "Camping_Task6_Icn";
    IdIcon["CancelIcn"] = "CancelIcn";
    IdIcon["CartIcn"] = "CartIcn";
    IdIcon["ChatUpdateIcn"] = "ChatUpdateIcn";
    IdIcon["CheckIcn"] = "CheckIcn";
    IdIcon["ChristmasIcn"] = "ChristmasIcn";
    IdIcon["ChristmasThemedEventTask_1_Icn"] = "Christmas_Task1_Icn";
    IdIcon["ChristmasThemedEventTask_2_Icn"] = "SnowFlakesIcn";
    IdIcon["ChristmasThemedEventTask_3_Icn"] = "Christmas_Task3_Icn";
    IdIcon["ChristmasThemedEventTask_4_Icn"] = "CandlesIcn";
    IdIcon["ChristmasThemedEventTask_5_Icn"] = "Christmas_Task5_Icn";
    IdIcon["ChristmasThemedEventTask_6_Icn"] = "GiftsIcn";
    IdIcon["ConstructionTimeIcn"] = "ConstructionTimeIcn";
    IdIcon["ContractsMarketIcn"] = "ContractsMarketIcn";
    IdIcon["Coop_updates_Icn"] = "Coop_updates_Icn";
    IdIcon["CooperativeIcn"] = "CooperativeIcn";
    IdIcon["CoopFundsIcn"] = "CoopFundsIcn";
    IdIcon["CoopInviteIcn"] = "CoopInviteIcn";
    IdIcon["CoopProjectIcn"] = "CoopProjectIcn";
    IdIcon["CoopVillageIcn"] = "CoopVillageIcn";
    IdIcon["CoopXpBoostIcn"] = "CoopXpBoostIcn";
    IdIcon["CoopXpIcn"] = "CoopXpIcn";
    IdIcon["CustomerSatisfactionIcn"] = "CustomerSatisfactionIcn";
    IdIcon["DecorationsIcn"] = "DecorationsIcn";
    IdIcon["DemolishIcn"] = "DemolishIcn";
    IdIcon["DogTabIcn"] = "DogTabIcn";
    IdIcon["EasterIcn"] = "EasterIcn";
    IdIcon["EasterThemedEventTask_1_Icn"] = "EasterEggsIcn";
    IdIcon["EasterThemedEventTask_2_Icn"] = "CornIcn";
    IdIcon["EasterThemedEventTask_3_Icn"] = "PaintingColorIcn";
    IdIcon["EasterThemedEventTask_4_Icn"] = "ChickenfeedIcn";
    IdIcon["EasterThemedEventTask_5_Icn"] = "EggsIcn";
    IdIcon["EasterThemedEventTask_6_Icn"] = "ChocolateBunnyIcn";
    IdIcon["Empty"] = "";
    IdIcon["ExclamationMarkEventIcn"] = "ExclamationMarkEventIcn";
    IdIcon["ExclamationMarkIcn"] = "ExclamationMarkIcn";
    IdIcon["ExpandFarmIcn"] = "ExpandFarmIcn";
    IdIcon["ExpansionSaleIcn"] = "ExpansionSaleIcn";
    IdIcon["FairytaleIcn"] = "FairytaleIcn";
    IdIcon["FairytaleThemedEventTask_1_Icn"] = "Fairytale_Task1_Icn";
    IdIcon["FairytaleThemedEventTask_2_Icn"] = "StorybookPagesIcn";
    IdIcon["FairytaleThemedEventTask_3_Icn"] = "Fairytale_Task3_Icn";
    IdIcon["FairytaleThemedEventTask_4_Icn"] = "BreadCrumbsIcn";
    IdIcon["FairytaleThemedEventTask_5_Icn"] = "Fairytale_Task5_Icn";
    IdIcon["FairytaleThemedEventTask_6_Icn"] = "FirefliesIcn";
    IdIcon["FarmBoostersIcn"] = "FarmBoostersIcn";
    IdIcon["FarmCupIcn"] = "FarmCupIcn";
    IdIcon["FarmCupThemedEventTask_1_Icn"] = "FarmCup_Task1_Icn";
    IdIcon["FarmCupThemedEventTask_2_Icn"] = "GoalsIcn";
    IdIcon["FarmCupThemedEventTask_3_Icn"] = "FarmCup_Task3_Icn";
    IdIcon["FarmCupThemedEventTask_4_Icn"] = "FootballsIcn";
    IdIcon["FarmCupThemedEventTask_5_Icn"] = "FarmCup_Task5_Icn";
    IdIcon["FarmCupThemedEventTask_6_Icn"] = "TrophiesIcn";
    IdIcon["WeddingIcn"] = "WeddingIcn";
    IdIcon["WeddingThemedEventTask_1_Icn"] = "InvitationsIcn";
    IdIcon["WeddingThemedEventTask_2_Icn"] = "WildflowerBouquetIcn";
    IdIcon["WeddingThemedEventTask_3_Icn"] = "EggsIcn";
    IdIcon["WeddingThemedEventTask_4_Icn"] = "CandyAppleIcn";
    IdIcon["WeddingThemedEventTask_5_Icn"] = "WeddingPresentsIcn";
    IdIcon["WeddingThemedEventTask_6_Icn"] = "WeddingBouquetIcn";
    IdIcon["FarmDollarsIcn"] = "FarmDollarsIcn";
    IdIcon["FarmDollarShop_1_Icn"] = "FarmDollarShop_1_Icn";
    IdIcon["FarmNameIcn"] = "FarmNameIcn";
    IdIcon["FeedbackIcn"] = "FeedbackIcn";
    IdIcon["FoodTruckIcn"] = "FoodTruckIcn";
    IdIcon["FoodTruckThemedEventTask_1_Icn"] = "PizzaIcn";
    IdIcon["FoodTruckThemedEventTask_2_Icn"] = "CornIcn";
    IdIcon["FoodTruckThemedEventTask_3_Icn"] = "FriesIcn";
    IdIcon["FoodTruckThemedEventTask_4_Icn"] = "SaladIcn";
    IdIcon["FoodTruckThemedEventTask_5_Icn"] = "FruitBasketIcn";
    IdIcon["FoodTruckThemedEventTask_6_Icn"] = "TacosIcn";
    IdIcon["Fuel1dayIcn"] = "Fuel1dayIcn";
    IdIcon["GenericThemedEventBuilding"] = "GenericThemedEventBuilding";
    IdIcon["GiftFreeIcn"] = "GiftFreeIcn";
    IdIcon["GiftGoldIcn"] = "GiftGoldIcn";
    IdIcon["GiftIcn"] = "GiftIcn";
    IdIcon["GiftPremiumIcn"] = "GiftPremiumIcn";
    IdIcon["GoldCupIcn"] = "GoldCupIcn";
    IdIcon["SilverCupIcn"] = "SilverCupIcn";
    IdIcon["BronzeCupIcn"] = "BronzeCupIcn";
    IdIcon["GoldIcn"] = "GoldIcn";
    IdIcon["GreenArrowIcn"] = "GreenArrowIcn";
    IdIcon["GreenArrowUpIcn"] = "GreenArrowUpIcn";
    IdIcon["GridIcn"] = "GridIcn";
    IdIcon["HalloweenIcn"] = "HalloweenIcn";
    IdIcon["HalloweenThemedEventTask_1_Icn"] = "Halloween_Task1_Icn";
    IdIcon["HalloweenThemedEventTask_2_Icn"] = "PumpkinsIcn";
    IdIcon["HalloweenThemedEventTask_3_Icn"] = "Halloween_Task3_Icn";
    IdIcon["HalloweenThemedEventTask_4_Icn"] = "FirewoodIcn";
    IdIcon["HalloweenThemedEventTask_5_Icn"] = "Halloween_Task5_Icn";
    IdIcon["HalloweenThemedEventTask_6_Icn"] = "SweetsIcn";
    IdIcon["HappinessNegativeIcn"] = "HappinessNegativeIcn";
    IdIcon["HappinessPositiveIcn"] = "HappinessPositiveIcn";
    IdIcon["HawaiiIcn"] = "HawaiiIcn";
    IdIcon["HawaiiThemedEventTask_1_Icn"] = "Hawaii_Task1_Icn";
    IdIcon["HawaiiThemedEventTask_2_Icn"] = "ThemedCoconutsIcn";
    IdIcon["HawaiiThemedEventTask_3_Icn"] = "Hawaii_Task3_Icn";
    IdIcon["HawaiiThemedEventTask_4_Icn"] = "SeashellsIcn";
    IdIcon["HawaiiThemedEventTask_5_Icn"] = "Hawaii_Task5_Icn";
    IdIcon["HawaiiThemedEventTask_6_Icn"] = "FlowerBlossomsIcn";
    IdIcon["HumusIcn"] = "HumusIcn";
    IdIcon["HumusSeaweedIcn"] = "HumusSeaweedIcn";
    IdIcon["ImprovementIcn"] = "ImprovementIcn";
    IdIcon["InactiveOutlinedIcn"] = "InactiveOutlinedIcn";
    IdIcon["InfoIcn"] = "InfoIcn";
    IdIcon["InternationalIcn"] = "InternationalIcn";
    IdIcon["InventoryIcn"] = "InventoryIcn";
    IdIcon["KickIcn"] = "KickIcn";
    IdIcon["LeagueCoopMedal0Icn"] = "LeagueCoopMedal0Icn";
    IdIcon["LeagueCoopMedal1Icn"] = "LeagueCoopMedal1Icn";
    IdIcon["LeagueCoopMedal2Icn"] = "LeagueCoopMedal2Icn";
    IdIcon["LeagueCoopMedal3Icn"] = "LeagueCoopMedal3Icn";
    IdIcon["LeagueCoopMedal4Icn"] = "LeagueCoopMedal4Icn";
    IdIcon["LeaguePlayerMedal0Icn"] = "LeaguePlayerMedal0Icn";
    IdIcon["LeaguePlayerMedal1Icn"] = "LeaguePlayerMedal1Icn";
    IdIcon["LeaguePlayerMedal2Icn"] = "LeaguePlayerMedal2Icn";
    IdIcon["LeaguePlayerMedal3Icn"] = "LeaguePlayerMedal3Icn";
    IdIcon["LeaguePlayerMedal4Icn"] = "LeaguePlayerMedal4Icn";
    IdIcon["LeagueCollectMedal0Icn"] = "LeagueCollectMedal0Icn";
    IdIcon["LeagueCollectMedal1Icn"] = "LeagueCollectMedal1Icn";
    IdIcon["LeagueCollectMedal2Icn"] = "LeagueCollectMedal2Icn";
    IdIcon["LeagueCollectMedal3Icn"] = "LeagueCollectMedal3Icn";
    IdIcon["LeagueCollectMedal4Icn"] = "LeagueCollectMedal4Icn";
    IdIcon["LeaguePromotedIcn"] = "LeaguePromotedIcn";
    IdIcon["LeagueDemotedIcn"] = "LeagueDemotedIcn";
    IdIcon["LeaveAllianceIcn"] = "LeaveAllianceIcn";
    IdIcon["LockIcn"] = "LockIcn";
    IdIcon["LogOut_Icn"] = "LogOut_Icn";
    IdIcon["LoyaltyPointsIcn"] = "LoyaltyPointsIcn";
    IdIcon["MarketXpIcn"] = "MarketXpIcn";
    IdIcon["MinusIcn"] = "MinusIcn";
    IdIcon["MoveIcn"] = "MoveIcn";
    IdIcon["MusicIcn"] = "MusicIcn";
    IdIcon["NurseryIcn"] = "NurseryIcn";
    IdIcon["OnlineIcn"] = "OnlineIcn";
    IdIcon["OpenAllianceIcn"] = "OpenAllianceIcn";
    IdIcon["OptionsFullscreenCloseIcn"] = "OptionsFullscreenCloseIcn";
    IdIcon["OptionsFullscreenIcn"] = "OptionsFullscreenIcn";
    IdIcon["OptionsLogOutIcn"] = "OptionsLogOutIcn";
    IdIcon["OptionsMusicOffIcn"] = "OptionsMusicOffIcn";
    IdIcon["OptionsMusicOnIcn"] = "OptionsMusicOnIcn";
    IdIcon["OptionsSettingsIcn"] = "OptionsSettingsIcn";
    IdIcon["OptionsSoundOffIcn"] = "OptionsSoundOffIcn";
    IdIcon["OptionsSoundOnIcn"] = "OptionsSoundOnIcn";
    IdIcon["OptionsSupportIcn"] = "OptionsSupportIcn";
    IdIcon["OptionsZoomInIcn"] = "OptionsZoomInIcn";
    IdIcon["OptionsZoomOutIcn"] = "OptionsZoomOutIcn";
    IdIcon["PenIcn"] = "PenIcn";
    IdIcon["PlayerActivityIcn"] = "PlayerActivityIcn";
    IdIcon["PlayerIcn"] = "PlayerIcn";
    IdIcon["PlayerSettingsIcn"] = "PlayerSettingsIcn";
    IdIcon["PlusIcn"] = "PlusIcn";
    IdIcon["PlusIcnStroke"] = "PlusIcn_stroke";
    IdIcon["PlusResearchIcn"] = "PlusResearchIcn";
    IdIcon["PointsIcn"] = "PointsIcn";
    IdIcon["PhoneIcn"] = "PhoneIcn";
    IdIcon["ProductionCostIcn"] = "ProductionCostIcn";
    IdIcon["ProductionIcn"] = "ProductionIcn";
    IdIcon["QuestbookIcn"] = "QuestbookIcn";
    IdIcon["QuestFinishIcn"] = "QuestFinishIcn";
    IdIcon["QuestUpdateIcn"] = "QuestUpdateIcn";
    IdIcon["RatingStarEmptyIcon"] = "RatingStarEmptyIcn";
    IdIcon["RatingStarFillIcn"] = "RatingStarFillIcn";
    IdIcon["RedArrowIcn"] = "RedArrowIcn";
    IdIcon["RegisterIcn"] = "RegisterIcn";
    IdIcon["RitaIcn"] = "RitaIcn";
    IdIcon["RotateIcn"] = "RotateIcn";
    IdIcon["SaleIcn"] = "SaleIcn";
    IdIcon["SearchIcn"] = "SearchIcn";
    IdIcon["SettingsIcn"] = "SettingsIcn";
    IdIcon["ShopIcn"] = "ShopIcn";
    IdIcon["ShopOfferArrow"] = "ShopOfferArrow";
    IdIcon["SMSIcn"] = "SMSIcn";
    IdIcon["SoundIcn"] = "SoundIcn";
    IdIcon["SowIcn"] = "SowIcn";
    IdIcon["StampGfx"] = "StampGfx";
    IdIcon["StorageIcn"] = "StorageIcn";
    IdIcon["SupportIcn"] = "SupportIcn";
    IdIcon["TimeIcn"] = "TimeIcn";
    IdIcon["TopRankIcn"] = "TopRankIcn";
    IdIcon["Tournament_rewards_Inc"] = "Tournament_rewards_Inc";
    IdIcon["TournamentRankingIcn"] = "TournamentRankingIcn";
    IdIcon["TrashIcn"] = "TrashIcn";
    IdIcon["UfoIcn"] = "UfoIcn";
    IdIcon["UfoThemedEventTask_1_Icn"] = "Ufo_Task1_Icn";
    IdIcon["UfoThemedEventTask_2_Icn"] = "UfoPartsIcn";
    IdIcon["UfoThemedEventTask_3_Icn"] = "Ufo_Task3_Icn";
    IdIcon["UfoThemedEventTask_4_Icn"] = "EvidencePhotosIcn";
    IdIcon["UfoThemedEventTask_5_Icn"] = "Ufo_Task5_Icn";
    IdIcon["UfoThemedEventTask_6_Icn"] = "StrangeTracksIcn";
    IdIcon["CoopFlag"] = "CoopFlag";
    IdIcon["CoopUpdatesIcn"] = "CoopUpdatesIcn";
    IdIcon["UpgradeIcn"] = "UpgradeIcn";
    IdIcon["WaterIcn"] = "WaterIcn";
    IdIcon["WhiteArrowIcn"] = "WhiteArrowIcn";
    IdIcon["WorkersIcn"] = "WorkersIcn";
    IdIcon["WebOnlyGiftIcn"] = "WebOnlyGiftBtn ";
    IdIcon["XpAdventureIcn"] = "XpAdventureIcn";
    IdIcon["XpIcn"] = "XpIcn";
    IdIcon["LevelUpIcn"] = "LevelUpIcn";
    IdIcon["AnimationsIcn"] = "AnimationsIcn";
    IdIcon["PrimeSaleIcn"] = "PrimeSaleIcn";
    IdIcon["GiftShopIcn"] = "GiftShopIcn";
    IdIcon["GoldCoinsDecoIcn"] = "GoldCoinsDecoIcn";
    IdIcon["ExclusiveWebOfferIcn"] = "ExclusiveWebOfferIcn";
    IdIcon["BeeIcn"] = "BeeIcn";
})(IdIcon || (IdIcon = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/IdIcon.ts
// module id = 10
// module chunks = 3